import React from "react";
import { CategoryCards } from "presto-react-components";

export default function Category(props) {
  return <CategoryCards.Category2 {...props} />;
}
